// Requirements: Colorgram.js, Chroma-js
// Extracted colors should generalize to a color in this list:
import { extract } from 'colorgram'
import chroma from 'chroma-js'

const closest_colors = [
  'F51836',
  'E91E63',
  'A727B0',
  '3F51B4',
  '03A7F1',
  '00BCD4',
  '00887C',
  '48A74C',
  'C1D036',
  'FFC107',
  'FF5722',
  '181818',
  'f3f1f4',
  '654321'
]

// Function for processing a single image, returns promise that can be resolved to 'output'
// function handleImage(file) {
//   return new Promise(function (resolve, reject) {
//     const reader = new FileReader()
//     if (/\.(jpe?g|png|tiff)$/i.test(file.name)) {
//       reader.onload = function (event) {
//         let img = new Image()
//         img.onload = function () {
//           var width = img.width
//           var canvas = document.createElement('canvas')
//           canvas.width = width
//           canvas.height = width * (img.height / img.width)
//           var ctx = canvas.getContext('2d')
//           ctx.drawImage(img, 0, 0, width, canvas.height)
//           var id = ctx.getImageData(0, 0, canvas.width, canvas.height)
//           var drawImg = { width: canvas.width, height: canvas.height, data: id.data, channels: 4, canvas: canvas }
//           var extracted = extract(drawImg, 7)
//
//           var final_colors = findClosestColor(extracted, extracted.length)
//
//           var output = []
//           output.push(file.name)
//           final_colors.forEach((e) => {
//             output.push(e)
//           })
//           resolve(output)
//         }
//         img.src = event.target.result
//       }
//       reader.readAsDataURL(file)
//     } else {
//       console.log('Incorrect type of uploaded file')
//       reject()
//     }
//   })
// }

// Uses handleImage function to load multiple files
// function readAllImages(event) {
//   var result = []
//   var files = event.target.files
//   for (let i = 0; i < files.length; i++) {
//     var file = files.item(i)
//     var colors = handleImage(file).then((val) => {
//       return val
//     })
//     colors.then((col) => {
//       // can add the output to an HTML object here
//       result.push(col)
//     })
//   }
// }

// For sorting color distances INCREASING by 0th index in each inner array
function sortDistance(x, y) {
  if (x[0] == y[0]) {
    return 0
  } else {
    return x[0] < y[0] ? -1 : 1
  }
}

// Determinates the closest color to param 'color'
function colorPicker(color) {
  var distances = []
  closest_colors.forEach((c) => {
    var distance = calculateLabDistance(c, color)
    distances.push([distance, c])
  })
  distances.sort(sortDistance)
  return distances[0][1]
}

// Calculates the euclidean distance from a color in 'closest_colors' and an extracted color (CIELAB color space)
function calculateLabDistance(close, color) {
  var color_lab = chroma([color[0], color[1], color[2]]).lab()
  var close_lab = chroma(close).lab()
  var difference = Math.sqrt((color_lab[0] - close_lab[0]) ** 2 + (color_lab[1] - close_lab[1]) ** 2 + (color_lab[2] - close_lab[2]) ** 2)
  return difference
}

// Finds the closest color for a given extracted color
// Only adds black, white, and brown as dominant colors if the proportion extracted exceeds a certain threshold
function findClosestColor(colors, extracted_length) {
  var closest = []
  let i = 0
  while (i < extracted_length) {
    if (closest.length == 3) {
      break
    }

    var closest_color = colorPicker(colors[i])

    // to view proportion of found color:
    //console.log(colors[i][3] + " " + closest_color);

    if (colors[i][3] > 0.07 && !closest.includes(closest_color)) {
      if (closest_color == '181818' && colors[i][3] > 0.35) {
        closest.push(closest_color)
      } else if (closest_color == 'f3f1f4' && colors[i][3] > 0.08) {
        closest.push(closest_color)
      } else if (closest_color == '654321' && colors[i][3] > 0.08) {
        closest.push(closest_color)
      } else if (closest_color != '181818' && closest_color != 'f3f1f4' && closest_color != '654321') {
        closest.push(closest_color)
      }
    }
    i++
  }
  return closest
}

// returns promise that image is loaded
function loadImage(path) {
  return new Promise((resolve) => {
    var image = new Image()
    image.addEventListener('load', () => {
      resolve(image)
    })
    image.src = path + '?' + new Date().getTime()
    image.crossOrigin = 'Anonymous'
  })
}

// For extracting dominant colors from a single image path
async function processImageUrl(path) {
  var img = await loadImage(path)
  //var img = await loadAndView(img);
  var width = img.width
  var canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = width * (img.height / img.width)
  var ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0, width, canvas.height)
  var id = ctx.getImageData(0, 0, canvas.width, canvas.height)
  var drawImg = { width: canvas.width, height: canvas.height, data: id.data, channels: 4, canvas: canvas }
  var extracted = extract(drawImg, 7)

  var final_colors = findClosestColor(extracted, extracted.length)

  return final_colors
}

// For extracting dominant colors from an array of image paths
// async function processMultipleImageUrls(paths) {
//   var dominant_colors = []
//   paths.forEach((c) => {
//     color = processImageUrl(c)
//     dominant_colors.push(color)
//   })
//
//   return dominant_colors
// }

export const processImage = (file, onSuccess, onError, onProgress) => {
  return processImageUrl(file)
}

// How processImage and processMultipleImages are used:
/*
let dom_colors = processImage(image);
dom_colors.then(function(colors) {
    console.log("Single image processed: ");
    console.log(colors);
})


let mult_dom_colors = processMultipleImages(images);

mult_dom_colors.then(function(colors) {
    console.log("Multiple images processed: ");
    colors.forEach(c => {
        c.then(function(co) {
            console.log(co);
        });
    });
});
*/
